export enum DateType {
  specific = 'specific',
  currentDay = 'currentDay',
  dayBeforeCurrent = 'dayBeforeCurrent',
  dayAfterCurrent = 'dayAfterCurrent',
  firstDayCurrentMonth = 'firstDayCurrentMonth',
  lastDayCurrentMonth = 'lastDayCurrentMonth',
  firstDayPriorMonth = 'firstDayPriorMonth',
  lastDayPriorMonth = 'lastDayPriorMonth',
  firstDayNextMonth = 'firstDayNextMonth',
  lastDayNextMonth = 'lastDayNextMonth'
}

export const dateTypeOptions = () =>
  Object.entries(DateType).map(([key, value]) => ({
    label: key,
    value: value
  }));

export const EtradeRequestBodyAccountOptions = [
  { label: 'All', value: 'ALL' },
  { label: 'Current', value: 'CURRENT' },
  { label: 'Terminated', value: 'TERMINATED' },
  { label: 'On leave', value: 'ON_LEAVE' }
];

export interface EtradeApiRequestBodyFilter {
  name: string;
  operator: string;
  values: string;
}

export interface EtradeApiRequestBodyTemplate {
  dayOfWeek?: number;
  reportName: string;
  reportViewName: string;
  account: string;
  beginDate: string;
  beginDateType: string;
  endDate: string;
  endDateType: string;
  filters: EtradeApiRequestBodyFilter[];
}

export const daysOfWeek = [
  { label: 'Mon', value: 1 },
  { label: 'Tue', value: 2 },
  { label: 'Wed', value: 3 },
  { label: 'Thu', value: 4 },
  { label: 'Fri', value: 5 },
  { label: 'Sat', value: 6 },
  { label: 'Sun', value: 0 }
];
